"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const ExpandCardButton_1 = __importDefault(require("../../atoms/ExpandCardButton"));
const ui_1 = require("@completeanatomy/ui/");
const GroupLabelPart_1 = __importDefault(require("../GroupLabelPart"));
const LabelCards_1 = __importDefault(require("../LabelCards"));
const bridge_1 = require("@completeanatomy/bridge");
const LabelsProvider_1 = require("../../providers/LabelsProvider");
const useLabelsReducer_1 = require("../../hooks/useLabelsReducer");
const ui_2 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const input_1 = require("../../utils/input");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const bridge_schema_2 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const lodash_1 = require("lodash");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const TOP_OFFSET = 100;
const BOTTOM_OFFSET = 200;
const EMPTY_PARTS_LIST = [];
// eslint-disable-next-line max-lines-per-function
function GroupLabelCard({ identifier, text, parts = EMPTY_PARTS_LIST, defaultPosition, locked, editable, onExpanded, selectedToolType = bridge_schema_2.ToolType.None, isAddingLabels, setShowLabelLines = lodash_1.noop, setOffsetChanged, }) {
    const bridge = (0, bridge_1.useBridge)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const toolsService = (0, providers_1.useToolsService)();
    const { selectedLabelID } = (0, hooks_1.useLabels)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const [, dispatch] = (0, LabelsProvider_1.useLabelsContext)();
    const [isExpanded, toggleExpanded] = (0, ui_1.useToggleState)(true);
    const [isEditing, setEditing] = (0, react_1.useState)(false);
    const [expandedHeight, setExpandedHeight] = (0, react_1.useState)(0);
    const [expandedOffset, setExpandedOffset] = (0, react_1.useState)(0);
    const textRef = (0, react_1.useRef)(null);
    const partsRef = (0, react_1.useRef)(null);
    const scrollViewRef = (0, react_1.useRef)(null);
    const partsLength = (0, react_1.useRef)(0);
    const partsElements = (0, react_1.useRef)([]);
    const partsElementsDict = (0, react_1.useRef)({});
    const labelRect = (0, react_1.useRef)({
        identifier,
        rect: { x: 0, y: 0, width: 0, height: 0 },
        parts: {},
    });
    const scrollOffset = (0, react_1.useRef)(0);
    const isSelected = identifier === selectedLabelID;
    const touchEventsSupported = (0, ui_2.isTouchEventsSupported)();
    const [isHighlighted, setHighlighted] = (0, react_1.useState)(false);
    const { isDesktop } = (0, device_1.usePlatform)();
    const focusTextField = (0, react_1.useCallback)(() => {
        const element = textRef.current;
        if (element) {
            /* wait for next frame to place caret to end after focus */
            setTimeout(() => {
                element.focus();
                (0, input_1.placeCaretAtEnd)(element);
            }, 0);
        }
    }, []);
    const unfocusTextField = (0, react_1.useCallback)(() => {
        var _a, _b, _c;
        (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        setEditing(false);
        setHighlighted(false);
        if (!isDesktop) {
            // Short delay to ensure positioning has settled after keyboard dismissal
            setTimeout(() => {
                setShowLabelLines(true);
                setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(false);
            }, 100);
        }
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelText(identifier, (_c = (_b = textRef.current) === null || _b === void 0 ? void 0 : _b.innerText) !== null && _c !== void 0 ? _c : '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifier, isDesktop]);
    const onDoubleClick = (0, react_1.useCallback)(() => {
        if (editable) {
            setEditing(true);
            focusTextField();
        }
        if (!isDesktop) {
            setShowLabelLines(false);
            setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(true);
        }
        if (!editable && selectedToolType === bridge_schema_2.ToolType.None) {
            setEditing(true);
            focusTextField();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editable, focusTextField, isDesktop]);
    const onClickOutside = (0, react_1.useCallback)(() => {
        unfocusTextField();
        onExpanded(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onTextKeyDown = (0, react_1.useCallback)((event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(false);
            unfocusTextField();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onExpand = (0, react_1.useCallback)(() => {
        let topOffset = 0;
        /* move label to top if don't have enough space */
        if (!isExpanded && partsRef.current) {
            const rect = partsRef.current.getBoundingClientRect();
            if (rect.top + expandedHeight > document.body.clientHeight) {
                topOffset =
                    document.body.clientHeight - (expandedHeight + BOTTOM_OFFSET);
            }
        }
        if (isExpanded) {
            bridge === null || bridge === void 0 ? void 0 : bridge.labelSelectPart('');
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectPart();
        }
        setExpandedOffset(topOffset);
        toggleExpanded();
        onExpanded(!isExpanded && !editable ? identifier : null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isExpanded,
        toggleExpanded,
        expandedHeight,
        bridge,
        labelManager,
        onExpanded,
    ]);
    const onRectUpdate = (0, react_1.useCallback)((rect) => {
        labelRect.current.rect = rect;
    }, []);
    const updatePartPositions = (0, react_1.useCallback)(() => {
        labelRect.current.parts = {};
        const labelY = labelRect.current.rect.y;
        const partsY = partsRef.current
            ? partsRef.current.getBoundingClientRect().top
            : 0;
        Object.keys(partsElementsDict.current).forEach((key) => {
            const el = partsElementsDict.current[key];
            const rect = el.getBoundingClientRect();
            labelRect.current.parts[key] = {
                offset: rect.top - labelY,
                scrollOffset: rect.top - partsY,
                height: rect.height,
            };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const calculateExpandedHeight = (0, react_1.useCallback)(() => {
        let elHeight = 0;
        let count = partsElements.current.length;
        count = Math.min(count, 4);
        for (let i = 0; i < count; i++) {
            const el = partsElements.current[i];
            const rect = el.getBoundingClientRect();
            elHeight += rect.height;
        }
        const maxHeight = document.body.clientHeight - (BOTTOM_OFFSET + TOP_OFFSET);
        const height = Math.min(maxHeight, elHeight);
        setExpandedHeight(height);
        const textHeight = textRef.current
            ? textRef.current.getBoundingClientRect().height
            : 0;
        labelRect.current.rect.height = textHeight + height;
        dispatch((0, useLabelsReducer_1.updateLabelRect)(labelRect.current));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onScroll = (0, react_1.useCallback)((delta) => {
        if (scrollOffset.current !== delta) {
            scrollOffset.current = delta;
            updatePartPositions();
            dispatch((0, useLabelsReducer_1.updateLabelParts)(labelRect.current));
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updatePartPositions]);
    const scrollToLast = () => {
        const scrollView = scrollViewRef.current;
        const lastElement = partsElements.current[partsElements.current.length - 1];
        if (scrollView && lastElement) {
            lastElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    };
    (0, react_1.useEffect)(() => {
        let timeout = 0;
        if (Array.isArray(parts) && parts.length > partsLength.current) {
            if (!isExpanded) {
                toggleExpanded();
                timeout = 300;
            }
            if (parts.length > 4) {
                scrollToLast();
            }
        }
        partsLength.current = parts ? parts.length : 0;
        setTimeout(() => {
            calculateExpandedHeight();
            updatePartPositions();
            dispatch((0, useLabelsReducer_1.updateLabelParts)(labelRect.current));
        }, timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parts, isExpanded]);
    partsElements.current = [];
    partsElementsDict.current = {};
    const setPartElement = (element, partID) => {
        if (element) {
            partsElements.current.push(element);
            partsElementsDict.current[partID] = element;
        }
    };
    const onClick = () => {
        if (!isHighlighted) {
            setHighlighted(true);
        }
        if (isExpanded && !editable && selectedToolType === bridge_schema_2.ToolType.None) {
            toggleExpanded();
            onExpanded(null);
        }
        if ((isExpanded &&
            selectedLabelID === identifier &&
            selectedToolType === bridge_schema_2.ToolType.LabelsLeft) ||
            selectedToolType === bridge_schema_2.ToolType.LabelsRight) {
            toggleExpanded();
        }
    };
    return ((0, jsx_runtime_1.jsx)(StyledLabelCard, { identifier: identifier, type: bridge_schema_1.LabelType.Group, defaultPosition: defaultPosition, expandedOffset: expandedOffset, locked: locked, onDoubleClick: onDoubleClick, onClickOutside: onClickOutside, onRectUpdate: onRectUpdate, isExpanded: isExpanded, parts: parts, textRef: textRef, isAddingLabels: isAddingLabels, editable: editable, "data-e2e": 'GroupLabelCard_StyledLabelCard', children: (0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'GroupLabelCard_Content', children: [(0, jsx_runtime_1.jsx)(Text, { ref: textRef, contentEditable: editable || isEditing, selected: isSelected, placeholder: t(i18n_1.Strings.tools.labels.placeholder), placeholderNotActive: touchEventsSupported
                        ? t(i18n_1.Strings.tools.labels.placeholderNotActiveTouch)
                        : t(i18n_1.Strings.tools.labels.placeholderNotActive), onClick: onClick, onTouchStart: onClick, onKeyDown: onTextKeyDown, onBlur: unfocusTextField, onDoubleClick: onDoubleClick, "data-e2e": 'GroupLabelCard_Text', children: text }), isSelected && Array.isArray(parts) && parts.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PartsContent, { role: "group", "aria-label": "Expanded", ref: partsRef, expanded: isExpanded, expandedHeight: expandedHeight, "data-e2e": 'GroupLabelCard_PartsContent', children: (0, jsx_runtime_1.jsx)(ui_1.ScrollView, { ref: scrollViewRef, hasScroll: parts.length > 4, onScroll: onScroll, "data-e2e": 'GroupLabelCard_ScrollView', children: parts.map(({ object }) => {
                                    return ((0, jsx_runtime_1.jsx)(GroupLabelPart_1.default, { ref: element => setPartElement(element, object.identifier), labelId: identifier, identifier: object.identifier, title: object.name, subtitle: object.latinName, selectedToolType: selectedToolType, "data-e2e": 'GroupLabelCard_GroupLabelPart' }, object.identifier));
                                }) }) }), (0, jsx_runtime_1.jsx)(ExpandCardButton_1.default, { expandable: isSelected, expanded: isExpanded, ellipsis: false, onClick: onExpand, "data-e2e": 'GroupLabelCard_ExpandCardButton' })] }))] }) }));
}
exports.default = GroupLabelCard;
const StyledLabelCard = (0, styled_components_1.default)(LabelCards_1.default) `
  padding: 0;

  ${({ expandedOffset }) => expandedOffset &&
    (0, styled_components_1.css) `
      top: ${expandedOffset}px;

      z-index: 1;
    `};
`;
const Content = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const Text = styled_components_1.default.div `
  color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};

  flex-grow: 1;

  min-height: 25px;

  padding: 10px;

  font-weight: ${({ selected }) => (selected ? '800' : '400')};
  font-size: 16px;

  outline: none;

  user-select: text;

  &:empty::after {
    color: ${({ theme }) => theme.textPlaceholder};

    content: attr(placeholder);
  }

  &:empty:not(:focus)::after {
    color: ${({ theme }) => theme.textPlaceholder};

    content: '${({ placeholderNotActive }) => placeholderNotActive}';
  }
`;
const PartsContent = styled_components_1.default.div `
  color: ${({ theme }) => theme.text};

  height: ${({ expanded, expandedHeight }) => expanded ? `${expandedHeight}px` : '0'};

  overflow: hidden;

  transition: height 0.3s;
`;
